import { render, staticRenderFns } from "./HistoricoPacientes.vue?vue&type=template&id=1feef084"
import script from "./HistoricoPacientes.vue?vue&type=script&lang=js"
export * from "./HistoricoPacientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports